/*------------------------------------------------------------------
Import external modules
------------------------------------------------------------------*/

import VideoEmbed from '../classes/video-embed';
import BackgroundVideo from '../classes/background-video';

/*------------------------------------------------------------------
Banner Slider
------------------------------------------------------------------*/

// Find the banner & slider
const banner = document.querySelector('.js-banner');
const slider = banner.querySelector('.js-banner__slider');
let autoplay = null;
slider.tns = tns({
  container: slider,
  mode: 'gallery',
  items: 1,
  slideBy: 1,
  autoplay: false,
  controls: false,
  nav: true,
  navPosition: 'bottom'
});

// Find all the slides
const items = [...slider.tns.getInfo().slideItems];

// Store our videos here
const videos = [];
const loadVideo = function () {
  let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  if (window.innerWidth >= 1024) {
    videos.forEach(video => {
      if (video.container == items[index]) {
        video.holder.appendChild(video.iframe.element);
        video.iframe.resize();
      } else {
        try {
          video.iframe.element.classList.remove('video-loaded');
          video.holder.removeChild(video.iframe.element);
        } catch (err) {}
      }
    });
  }
};
const clearIntervalEvent = () => {
  clearInterval(autoplay);
  banner.removeEventListener('click', clearIntervalEvent);
};

// Set up autoplay
autoplay = setInterval(() => {
  slider.tns.goTo('next');
}, 5000);
banner.addEventListener('click', clearIntervalEvent);
window.addEventListener('scripts-loaded', () => {
  items.forEach((slide, index) => {
    // // Find a video if there is one
    const video = slide.querySelector('[data-background-video]') || false;

    // If we have a video
    if (video) {
      // Create a video embed
      const embed = new VideoEmbed(video.getAttribute('data-background-video'), {
        mute: 1,
        loop: 1
      });
      const data = {
        container: slide,
        holder: video,
        index: index,
        iframe: new BackgroundVideo(embed.iframe)
      };
      const observer = new ResizeObserver(() => data.iframe.resize());
      observer.observe(video);
      videos.push(data);
      if (index === 0) loadVideo(index);
    }
  });
  slider.tns.events.on('indexChanged', data => loadVideo(data.index));
});